import { useState } from 'react';
import { clientService } from '../services/clientService';

/**
 * Custom hook for authentication operations
 */
export const useAuth = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // Register new client
  const register = async (clientData) => {
    setIsLoading(true);
    setError(null);
    
    const result = await clientService.register(clientData);
    
    if (result.success) {
      // Store auth data in localStorage
      localStorage.setItem('authToken', result.data.api_key);
      localStorage.setItem('clientId', result.data.id);
      localStorage.setItem('clientData', JSON.stringify(result.data));
    } else {
      setError(result.error);
    }
    
    setIsLoading(false);
    return result;
  };

  // Validate API key
  const validateApiKey = async (apiKey) => {
    setIsLoading(true);
    setError(null);
    
    const result = await clientService.validateApiKey(apiKey);
    
    if (result.success) {
      localStorage.setItem('authToken', apiKey);
      localStorage.setItem('clientId', result.data.client.id);
      localStorage.setItem('clientData', JSON.stringify(result.data.client));
    } else {
      setError(result.error);
    }
    
    setIsLoading(false);
    return result;
  };

  // Logout
  const logout = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('clientId');
    localStorage.removeItem('clientData');
    setError(null);
  };

  // Get current auth state
  const getAuthState = () => {
    const token = localStorage.getItem('authToken');
    const clientId = localStorage.getItem('clientId');
    const clientData = localStorage.getItem('clientData');
    
    return {
      isAuthenticated: !!token,
      apiKey: token,
      clientId: clientId,
      client: clientData ? JSON.parse(clientData) : null
    };
  };

  return {
    // State
    ...getAuthState(),
    isLoading,
    error,
    
    // Actions
    register,
    validateApiKey,
    logout,
    getAuthState
  };
}; 